var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReturnsinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M59 17 47 6H17L5 17v40h54zM5 18h54"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M46 26v9h-8M17 49v-9h8"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M20 34c1.375-4.592 4.648-7.708 9-9 3.69-.657 7.896.646 11 4l6 6m-29 5 6 6c3.104 3.354 7.31 4.657 11 4 4.352-1.292 7.625-4.408 9-9"
}))));
export default SvgReturnsinline;